import { getRequest, postRequest } from './request'

import { DOMAIN  } from './constant'

export const login = () => {
  return getRequest(`${DOMAIN}/auth/login`)
}

export const checkAuth = () => {
  return getRequest(`${DOMAIN}/auth/check`)
}

export const register = (account: {
  phoneNumber: string;
  smsCode: string;
  referralCode?: string;
}) => {
  return postRequest(`${DOMAIN}/auth/register`, account)
}

export const loginWith = (account: {
  type: 'password' | 'sms'
  userName?: string;
  password?: string;
  phoneNumber?: string;
  smsCode?: string;
}) => {
  return postRequest(`${DOMAIN}/auth/login`, account)
}

export const sendSmsCode = (phoneNumber: string, type: 'register' | 'login') => {
  return postRequest(`${DOMAIN}/auth/send-sms`, { phoneNumber, type })
}